/**
 * Create a success value usable in a functional chain.
 *
 * @param val - The return value to be encapsulated
 */
export const Success = (val) => Promise.resolve(val);
/**
 * Create a failure value usable in a functional chain.
 *
 * @param err - The error object to be encapsulated
 */
export const Failure = (err) => Promise.reject(err);
/**
 * Gain access to the environment of the function chain, and/or create a new
 * composable method.
 */
export class Reader {
    fn;
    constructor(fn) {
        this.fn = fn;
    }
    run(ctx) {
        return this.fn(ctx);
    }
    bind(g) {
        return new Reader((ctx) => {
            return this.fn(ctx).then((_) => g(_).run(ctx), Failure);
        });
    }
    map(g) {
        return new Reader((ctx) => {
            return this.fn(ctx).then(g, Failure);
        });
    }
    leftBind(g) {
        return new Reader((ctx) => {
            return this.fn(ctx).then(Success, (_) => g(_).run(ctx));
        });
    }
    leftMap(g) {
        return new Reader((ctx) => {
            return this.fn(ctx).then(Success, g);
        });
    }
    local(g) {
        return new Reader((ctx) => {
            return this.fn(g(ctx)).then(Success, Failure);
        });
    }
    static fromPromise(promise) {
        return new Reader((ctx) => promise(ctx).then(Success, Failure));
    }
}
